import React, { useState } from "react";
import styled from "styled-components";
import ExploreCard from "../../components/ui/ExploreCard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { farmProduct } from "../../assets/farmProduct";

const ExploreEquipments = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const products = farmProduct
    .slice(0, 8)
    .map((product) => <ExploreCard key={product.id} product={product} />);
  const itemsPerPage = 4;
  const totalPages = Math.ceil(products.length / itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + itemsPerPage >= products.length
        ? 0
        : prevIndex + itemsPerPage,
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - itemsPerPage < 0
        ? Math.max(0, products.length - itemsPerPage)
        : prevIndex - itemsPerPage,
    );
  };

  const currentProducts = products.slice(
    currentIndex,
    currentIndex + itemsPerPage,
  );

  return (
    <TheExploreEquipments>
      <div className="header">
        <h3>Explore Modified Equipment</h3>
        <div className="dots">
          {Array.from({ length: totalPages }).map((_, idx) => (
            <span
              key={idx}
              className={`dot ${Math.floor(currentIndex / itemsPerPage) === idx ? "active" : ""}`}
              onClick={() => setCurrentIndex(idx * itemsPerPage)}
            />
          ))}
        </div>
      </div>

      <div className="slider-container">
        <button className="nav-button prev" onClick={prevSlide}>
          <FaChevronLeft />
        </button>

        <div className="equipments">
          {currentProducts}
          {currentProducts.length < itemsPerPage &&
            Array(itemsPerPage - currentProducts.length)
              .fill()
              .map((_, idx) => (
                <div key={`empty-${idx}`} className="empty-card" />
              ))}
        </div>

        <button className="nav-button next" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>
    </TheExploreEquipments>
  );
};

const TheExploreEquipments = styled.div`
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 1.5rem;
  position: relative;
  background: var(--second-color);

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;

    h3 {
      font-size: 2rem;
      color: var(--primary-color);
      margin: 0;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 50px;
        height: 3px;
        background: var(--third-color);
        border-radius: 2px;
      }
    }

    .dots {
      display: flex;
      gap: 0.5rem;

      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #ccc;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: var(--third-color);
          transform: scale(1.2);
        }

        &.active {
          background: var(--third-color);
          width: 25px;
          border-radius: 5px;
        }
      }
    }
  }

  .slider-container {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    gap: 1rem;

    .nav-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background: var(--primary-color);
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      transition: all 0.3s ease;
      z-index: 10;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

      &:hover {
        background: var(--third-color);
        transform: translateY(-50%) scale(1.1);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      }

      &:active {
        transform: translateY(-50%) scale(0.95);
      }

      &.prev {
        left: -20px;
      }

      &.next {
        right: -20px;
      }
    }

    .equipments {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
      transition: all 0.3s ease;

      .empty-card {
        visibility: hidden;
      }
    }
  }
  @media screen and (max-width: 1366px) {
    padding: 1.8rem;

    .slider-container {
      .nav-button {
        width: 40px;
        height: 40px;
        font-size: 1rem;

        &.prev {
          left: -15px;
        }

        &.next {
          right: -15px;
        }
      }

      .equipments {
        gap: 1.5rem;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .slider-container {
      .equipments {
        gap: 1.2rem;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .slider-container {
      .equipments {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
      }

      .nav-button {
        width: 38px;
        height: 38px;
        font-size: 0.9rem;

        &.prev {
          left: -12px;
        }

        &.next {
          right: -12px;
        }
      }
    }

    .header {
      h3 {
        font-size: 1.6rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    padding: 1rem;

    .header {
      flex-direction: column;
      align-items: start;

      h3 {
        font-size: 1.4rem;
      }

      .dots {
        .dot {
          width: 8px;
          height: 8px;

          &.active {
            width: 20px;
          }
        }
      }
    }

    .slider-container {
      .nav-button {
        width: 32px;
        height: 32px;
        font-size: 0.8rem;

        &.prev {
          left: -8px;
        }

        &.next {
          right: -8px;
        }
      }

      .equipments {
        gap: 1rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .slider-container {
      .equipments {
        gap: 0.8rem;
      }

      .nav-button {
        width: 28px;
        height: 28px;
        font-size: 0.7rem;

        &.prev {
          left: -5px;
        }

        &.next {
          right: -5px;
        }
      }
    }

    .header {
      h3 {
        font-size: 1.2rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .slider-container {
      .equipments {
        gap: 0.6rem;
      }

      .nav-button {
        width: 25px;
        height: 25px;
        font-size: 0.6rem;
      }
    }
  }
`;

export default ExploreEquipments;
